import { cssPrefix } from '../../../../const/Constant';
import { Icon } from './Icon';
import { DropDownItem } from './base/DropDownItem';
import { TextWrappingContextMenu } from './contextmenu/textwrapping/TextWrappingContextMenu';

class TextWrapping extends DropDownItem {
  constructor(options = { contextMenu: {} }) {
    super(`${cssPrefix}-tools-text-wrapping`);
    this.options = options;
    this.icon = new Icon('text-wrap');
    this.setIcon(this.icon);
    this.setTitleTips('截断');
    this.textWrappingContextMenu = new TextWrappingContextMenu({
      el: this,
      ...this.options.contextMenu,
    }).parentWidget(this);
  }

  destroy() {
    super.destroy();
    this.textWrappingContextMenu.destroy();
  }
}

export { TextWrapping };
